import {CompanyLabel} from '../Enum/company-label.enum';
import {Document} from './document';

export class DocumentTable {
  id: number;
  uniqid: string;
  title: string;
  fileTitle: string;
  tags: string;
  filename: string;
  size: string;
  availableTo: string;
  availableSince: Date;
  uploadedBy: string;
  monitorDownloads: boolean;
  deleted: boolean;
  nbOfWatchers: number;

  constructor(document: Document, isNew: boolean) {
    this.id = document.id;
    this.uniqid = document.uniqid;
    if (document.tag === '') {
      if (isNew) {
        this.title = '<span class="font-weight-bold font-size-title">' + document.title + '</span>' + ' <br> '
          + '<span class="font-weight-bold text-success">' + 'New' + '</span>';
      } else {
        this.title = '<span class="font-weight-bold font-size-title">' + document.title + '</span>' + ' <br> ';
      }
    } else {
      if (isNew) {
        this.title = '<span class="font-weight-bold font-size-title">' + document.title + '</span>' + ' <br> '
          + '<span class="font-weight-bold text-muted font-size-tag">' + document.tag + '</span>' + ' <br> '
          + '<span class="font-weight-bold text-success">' + 'New' + '</span>';
      } else {
        this.title = '<span class="font-weight-bold font-size-title">' + document.title + '</span>' + ' <br> '
          + '<span class="font-weight-bold text-muted font-size-tag">' + document.tag + '</span>' + ' <br> ';
      }
    }

    this.deleted = document.deleted;
    if (document.deleted) {
      this.title = this.title + ' ' + '<span class="font-weight-bold text-danger">' + 'Deleted' + '</span>';
    }
    this.fileTitle = document.title.trim();
    this.tags = document.tag;
    this.filename = document.filename;
    const size = Math.floor(document.size / 1024);
    if (document.size < 1024) {
      this.size = '' + document.size + ' B';
    } else if (size > 2000) {
      this.size = '' + Math.floor(size / 1000) + ' MB';
    } else {
      this.size = '' + size + ' KB';
    }
    this.availableTo = this.getDocumentAvailableTo(document);
    this.availableSince = document.availableSince;
    this.uploadedBy = document.uploadedBy;
    this.monitorDownloads = document.monitor;
  }

  private getDocumentAvailableTo(document: Document) {
    if (document.label === 0) {
      return 'Selected clients';
    }
    let availableTo = '';
    if (document.label === CompanyLabel.LABEL_ALL) {
      availableTo = 'All clients';
    } else if (document.label === CompanyLabel.LABEL_MCKAY) {
      availableTo = 'McKay clients only';
    } else if (document.label === CompanyLabel.LABEL_QUINCY) {
      availableTo = 'Quincy clients only';
    } else if (document.label === CompanyLabel.LABEL_VENDOR) {
      availableTo = 'Vendor only';
    } else if (document.label === CompanyLabel.LABEL_MCKAY_VENDOR) {
      availableTo = 'McKay clients & vendors';
    } else if (document.label === CompanyLabel.LABEL_QUINCY_VENDOR) {
      availableTo = 'Quincy clients & vendors';
    } else if (document.label === CompanyLabel.LABEL_ALL_VENDOR) {
      availableTo = 'Clients & vendors';
    }
    if (document.company.length > 0) {
      availableTo += ' and selected clients';
    }
    return availableTo;
  }
}
